<template>
  <div class="profile-dropdown-wrapper">
    <VaDropdown v-model="isShown" :offset="[9, 0]" class="profile-dropdown" stick-to-edges>
      <template #anchor>
        <span class="profile-dropdown__anchor min-w-max">
          <slot />
          <div class="flex gap-4 items-center">
            <div
              class="px-2 py-2 border bg-blue-100 hover:bg-blue-200 text-primary rounded-lg flex items-center justify-center"
            >
              <p class="uppercase">{{ authStore.firstName.charAt(0) + authStore.lastName.charAt(0) }}</p>
            </div>
          </div>
        </span>
      </template>
      <VaDropdownContent
        class="profile-dropdown__content md:w-60 px-0 py-0 w-full mt-2"
        :style="{ '--hover-color': hoverColor }"
      >
        <div class="px-4 py-4 pb-6 mb-4" style="background-color: #f9fafb">
          <p class="font-medium text-lg">
            {{ authStore.firstName + ' ' + authStore.lastName }}
          </p>
          <p class="font-light mt-1 text-md mt-3">
            {{ authStore.email }}
          </p>
        </div>
        <VaList v-for="group in displayOptions" :key="group.name">
          <header v-if="group.name" class="uppercase text-[var(--va-secondary)] opacity-80 text-xs px-4">
            {{ t(`user.${group.name}`) }}
          </header>
          <VaListItem
            v-for="item in group.list"
            :key="item.name"
            class="menu-item px-4 text-base cursor-pointer h-8 mb-2"
          >
            <div v-if="item.name === 'logout'" class="text-sm" @click="showModal = true">
              <VaIcon :name="item.icon" class="pr-2" color="secondary" />
              {{ t(`user.${item.name}`) }}
            </div>
            <div v-else class="text-sm capitalize" @click="redirectToPage(item.to)">
              <!-- <VaIcon :name="item.icon" class="pr-2" color="secondary" /> -->
              <div class="flex gap-4">
                <div>
                  <!-- <img :src="item.icon" width="20" height="20" alt="" /> -->
                  <div v-if="item.name === 'account'" style="width: 20px; height: 20px">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="20"
                      height="20"
                      x="0"
                      y="0"
                      viewBox="0 0 512 512"
                      style="enable-background: new 0 0 512 512"
                      xml:space="preserve"
                      class=""
                    >
                      <g>
                        <path
                          d="M256 292.1c33 0 63.5-9.3 87.9-25.1 18.9-12.1 43.5-10.1 60.1 5 46.1 41.8 72.3 101.1 72.2 163.4v26.7c0 27.6-22.4 49.9-50 49.9H85.8c-27.6 0-50-22.3-50-49.9v-26.7c-.2-62.2 26-121.6 72.1-163.3 16.6-15.1 41.3-17.1 60.1-5 24.5 15.7 54.9 25 88 25z"
                          fill="#767c88"
                          opacity="1"
                          data-original="#000000"
                          class=""
                        ></path>
                        <circle
                          cx="256"
                          cy="123.8"
                          r="123.8"
                          fill="#767c88"
                          opacity="1"
                          data-original="#000000"
                          class=""
                        ></circle>
                      </g>
                    </svg>
                  </div>
                  <div v-else-if="item.name === 'admin'" style="width: 20px; height: 20px">
                    <VaIcon name="mso-admin_panel_settings" size="20px" color="secondary" />
                  </div>
                  <div v-else-if="item.name === 'alerts'" style="width: 20px; height: 20px">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="20"
                      height="20"
                      x="0"
                      y="0"
                      viewBox="0 0 512 512"
                      style="enable-background: new 0 0 512 512"
                      xml:space="preserve"
                      class=""
                    >
                      <g>
                        <path
                          d="M448 232.148c-11.777 0-21.332-9.554-21.332-21.332 0-59.84-23.297-116.074-65.602-158.402-8.34-8.34-8.34-21.82 0-30.164 8.34-8.34 21.825-8.34 30.164 0 50.372 50.367 78.102 117.336 78.102 188.566 0 11.778-9.555 21.332-21.332 21.332zM21.332 232.148C9.559 232.148 0 222.594 0 210.816 0 139.586 27.734 72.617 78.102 22.25c8.34-8.34 21.824-8.34 30.164 0 8.343 8.344 8.343 21.824 0 30.164C65.96 94.72 42.668 150.977 42.668 210.816c0 11.778-9.559 21.332-21.336 21.332zM434.754 360.813C402.496 333.546 384 293.695 384 251.476V192c0-75.07-55.766-137.215-128-147.625V21.332C256 9.535 246.441 0 234.668 0c-11.777 0-21.336 9.535-21.336 21.332v23.043c-72.254 10.41-128 72.555-128 147.625v59.477c0 42.218-18.496 82.07-50.941 109.503a37.262 37.262 0 0 0-13.059 28.352c0 20.59 16.746 37.336 37.336 37.336h352c20.586 0 37.332-16.746 37.332-37.336 0-10.922-4.758-21.246-13.246-28.52zM234.668 512c38.633 0 70.953-27.543 78.379-64H156.289c7.422 36.457 39.742 64 78.379 64zm0 0"
                          fill="#767c88"
                          opacity="1"
                          data-original="#000000"
                          class=""
                        ></path>
                      </g>
                    </svg>
                  </div>
                  <div></div>
                </div>
                <div>{{ t(`${item.name}`) }}</div>
              </div>
            </div>
          </VaListItem>
          <VaListSeparator v-if="group.separator" class="mx-3 my-2" />
        </VaList>
      </VaDropdownContent>
    </VaDropdown>
  </div>
  <VaModal
    v-model="showModal"
    message="Are you sure you want to logout ?"
    ok-text="Logout"
    blur
    :size="'small'"
    @ok="logout()"
    @cancel="handleLogoutFail()"
  />
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useColors } from 'vuestic-ui'
import { useRouter } from 'vue-router'
import { useToast } from 'vuestic-ui'
import { useAuthStore } from '@/stores/authStore.js'
import { useDomainStore } from '../../../../stores/dashBoardStore'

const { colors, setHSLAColor } = useColors()
const hoverColor = computed(() => setHSLAColor(colors.focus, { a: 0.1 }))

const { push } = useRouter()
const { init } = useToast()

const auth = useAuthStore()
const showModal = ref(false)
const pageStore = useDomainStore()
const authStore = useAuthStore()

const { t } = useI18n()

type ProfileListItem = {
  name: string
  to?: string
  href?: string
  icon: string
}

type ProfileOptions = {
  name: string
  separator: boolean
  list: ProfileListItem[]
}

const props = withDefaults(
  defineProps<{
    options?: ProfileOptions[]
  }>(),
  {
    options: () => [
      {
        name: '',
        separator: false,
        list: [
          {
            name: 'account',
            to: 'profile',
            icon: '/src/assets/icons/profDark.svg',
          },
          {
            name: 'alerts',
            to: 'alerts',
            icon: '/src/assets/icons/darkBell.svg',
          },
        ],
      },
      {
        name: '',
        separator: false,
        list: [
          {
            name: 'logout',
            // to: 'logout',
            icon: 'mso-logout',
          },
        ],
      },
    ],
  },
)

const logout = () => {
  auth.logout()
  if (!auth.token) {
    push({ name: 'login' })
  } else {
    init({ message: 'Logout failed', color: 'danger' })
    push({ name: 'dashboard' })
  }
}

const redirectToPage = (val) => {
  pageStore.setAccountPage(val)
  push({ name: val })
}

const handleLogoutFail = () => {
  showModal.value = false
}

const isShown = ref(false)

// Admin Panel entry is injected, and Account/Alerts are dropped for external users
// (they only ever get Inbox Monitor - no profile/account or domain-alert access),
// reactively based on the auth store rather than baked into the static `options`
// prop default, so it still lets callers override `options` entirely if needed.
const displayOptions = computed<ProfileOptions[]>(() => {
  let opts = props.options

  if (auth.isExternal) {
    opts = opts
      .map((group) => ({
        ...group,
        list: group.list.filter((item) => item.name !== 'account' && item.name !== 'alerts'),
      }))
      .filter((group) => group.list.length > 0)
  }

  // An external user is never also treated as admin here, regardless of their
  // stored role - external accounts get Inbox Monitor and nothing else.
  // external_manager also reaches the Admin Panel, just with a narrower scope
  // once there (create/manage external users only).
  if (auth.isExternal || (!auth.isAdmin && !auth.isExternalManager)) return opts

  return opts.map((group, index) => {
    if (index !== 0) return group
    if (group.list.some((item) => item.name === 'admin')) return group
    return {
      ...group,
      list: [...group.list, { name: 'admin', to: 'admin-panel', icon: 'admin_panel_settings' }],
    }
  })
})
</script>

<style lang="scss">
.profile-dropdown {
  cursor: pointer;

  &__content {
    .menu-item:hover {
      background: var(--hover-color);
    }
  }

  &__anchor {
    display: inline-block;
  }
}
.user-box {
  // padding: 10px;
  border-radius: 5px;
  border: 1px solid coral;
  width: 30px;
  height: 30px;
  background-color: coral;
  color: white;
}
</style>
